import React from 'react';
import { Link } from 'react-router-dom';

export const LandingPage: React.FC = () => {
  return (
    <div className="min-h-screen">
      <nav className="flex items-center justify-between px-8 py-4 bg-white shadow">
        <span className="text-xl font-bold text-blue-600">Care Diary</span>
        <div className="space-x-4">
          <Link to="/login" className="text-gray-700 hover:text-blue-600">Log In</Link>
          <Link to="/signup" className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">Sign Up</Link>
        </div>
      </nav>
      <section className="py-20 px-8 text-center bg-blue-50">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">Care Diary</h1>
        <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
          Track, share, and coordinate care for your loved ones with ease.
        </p>
        <div className="space-x-4">
          <Link to="/signup" className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700">Get Started</Link>
          <Link to="/faq" className="bg-white text-blue-600 px-6 py-3 rounded-lg border border-blue-600 hover:bg-blue-50">Learn More</Link>
        </div>
      </section>
      <section className="py-16 px-8 max-w-5xl mx-auto">
        <div className="grid md:grid-cols-3 gap-8">
          <div data-testid="value-prop" className="text-center p-6">
            <div className="text-4xl mb-4">📋</div>
            <h3 className="text-lg font-semibold mb-2">Daily Care Log</h3>
            <p className="text-gray-600">Record meals, medications, and activities all in one place.</p>
          </div>
          <div data-testid="value-prop" className="text-center p-6">
            <div className="text-4xl mb-4">👨‍👩‍👧‍👦</div>
            <h3 className="text-lg font-semibold mb-2">Family Sharing</h3>
            <p className="text-gray-600">Keep everyone in the loop with real-time updates.</p>
          </div>
          <div data-testid="value-prop" className="text-center p-6">
            <div className="text-4xl mb-4">🔒</div>
            <h3 className="text-lg font-semibold mb-2">Secure & Private</h3>
            <p className="text-gray-600">Your data is encrypted and access-controlled.</p>
          </div>
        </div>
      </section>
      <section className="py-16 px-8 bg-gray-50 text-center">
        <h2 className="text-2xl font-bold mb-4">Ready to get started?</h2>
        <p className="text-gray-600 mb-6">Join families who trust Care Diary to coordinate care.</p>
        <Link to="/signup" className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700">Create Free Account</Link>
      </section>
      <footer className="py-8 px-8 bg-gray-800 text-gray-400 text-center">
        <p>&copy; 2026 Care Diary. All rights reserved.</p>
        <div className="mt-2 space-x-4">
          <Link to="/enquiry" className="hover:text-white">Contact Us</Link>
          <Link to="/faq" className="hover:text-white">FAQ</Link>
        </div>
      </footer>
    </div>
  );
};